import React from 'react';
import {Icon} from 'antd';

import InstructionLayout, {
    InstructionSpotlight,
    InstructionStep
} from '../instruction-layout';


const navigationItems = [
    {
        id: 'loading-section',
        number: 1,
        content: (
            <>
                Перейдите в раздел
                <strong> «Погрузка-разгрузка»</strong>.
            </>
        ),
        area: {
            top: 10,
            left: 21.7,
            width: 12.5,
            height: 28
        }
    }
];


const openPhotoUploadItems = [
    {
        id: 'delivery',
        number: 2,
        content: 'Найдите нужный рейс.',
        area: {
            top: 2,
            left: 1,
            width: 22,
            height: 61
        }
    },
    {
        id: 'attach-photo',
        number: 3,
        content: (
            <>
                Нажмите кнопку
                <strong> «Прикрепить фото»</strong>.
            </>
        ),
        area: {
            top: 46.31,
            left: 80.37,
            width: 18.73,
            height: 15.04
        }
    }
];


const requiredPhotoItems = [
    {
        id: 'tractor-driver',
        number: 1,
        content:
            'Загрузите фотографию тягача с водителем, на которой виден государственный номер тягача.',
        area: {
            top: 21,
            left: 6.7,
            width: 42,
            height: 12.5
        }
    },
    {
        id: 'tractor-vin-close',
        number: 2,
        content:
            'Загрузите фотографию VIN-номера тягача крупным планом.',
        area: {
            top: 21,
            left: 50,
            width: 42,
            height: 12.5
        }
    },
    {
        id: 'tractor-vin-distance',
        number: 3,
        content:
            'Загрузите фотографию VIN-номера тягача с расстояния, на которой водитель указывает его местонахождение.',
        area: {
            top: 38.3,
            left: 6.7,
            width: 42,
            height: 12.5
        }
    },
    {
        id: 'trailer-vin-close',
        number: 4,
        content:
            'Загрузите фотографию VIN-номера прицепа крупным планом.',
        area: {
            top: 38.3,
            left: 50,
            width: 42,
            height: 12.5
        }
    },
    {
        id: 'trailer-vin-distance',
        number: 5,
        content:
            'Загрузите фотографию VIN-номера прицепа с расстояния, на которой водитель указывает его местонахождение.',
        area: {
            top: 55.7,
            left: 6.7,
            width: 42,
            height: 12.5
        }
    },
    {
        id: 'trailer-driver',
        number: 6,
        content:
            'Загрузите фотографию государственного номера прицепа с водителем.',
        area: {
            top: 55.7,
            left: 50,
            width: 42,
            height: 12.5
        }
    },
    {
        id: 'tractor-no-vin',
        number: 7,
        content: (
            <>
                Если VIN-номер тягача отсутствует, установите флажок
                <strong> «У автомобиля нет VIN номера»</strong>.
            </>
        ),
        area: {
            top: 73.5,
            left: 6,
            width: 22,
            height: 6
        }
    },
    {
        id: 'trailer-no-vin',
        number: 8,
        content: (
            <>
                Если VIN-номер прицепа отсутствует, установите флажок
                <strong> «У прицепа нет VIN номера»</strong>.
            </>
        ),
        area: {
            top: 73.5,
            left: 35,
            width: 22,
            height: 6
        }
    }
];


const submitPhotoItems = [
    {
        id: 'submit-photos',
        number: 1,
        content: (
            <>
                Нажмите кнопку <strong>«Прикрепить»</strong>.
            </>
        ),
        area: {
            top: 86.24,
            left: 28.6,
            width: 17.59,
            height: 6.79
        }
    }
];


export default function VehicleInspectionInstruction() {
    return (
        <InstructionLayout title="Проверка ТС, прицепа и водителя">
            <p className="instruction-intro">
                Перед погрузкой сотрудник склада должен проверить
                транспортное средство, прицеп и водителя, а затем
                загрузить необходимые фотографии в карточку рейса.
            </p>

            <div className="service-highlight">
                <span className="service-highlight__icon">
                    <Icon type="camera"/>
                </span>

                <div>
                    <strong className="service-highlight__title">
                        Проверка перед погрузкой
                    </strong>

                    <p className="service-highlight__text">
                        Поставить транспортное средство на погрузку
                        можно после загрузки фотографий и передачи
                        информации в 1С.
                    </p>
                </div>
            </div>

            <InstructionStep
                number="1"
                title="Откройте форму загрузки фотографий"
            >
                <div className="instruction-copy">
                    <p>
                        Перейдите к списку рейсов, найдите нужный рейс
                        и откройте форму загрузки фотографий.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/vehicle-inspection/01-section-navigation.png"
                    alt="Раздел «Погрузка-разгрузка»"
                    items={navigationItems}
                />

                <InstructionSpotlight
                    src="/img/instructions/vehicle-inspection/02-open-photo-upload.png"
                    alt="Кнопка «Прикрепить фото» в карточке рейса"
                    items={openPhotoUploadItems}
                />
            </InstructionStep>

            <InstructionStep
                number="2"
                title="Прикрепите обязательные фотографии"
            >
                <div className="instruction-copy">
                    <p>
                        В открывшемся окне загрузите шесть фотографий
                        транспортного средства, прицепа и водителя.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/vehicle-inspection/03-required-photos.png"
                    alt="Форма загрузки обязательных фотографий транспортного средства"
                    items={requiredPhotoItems}
                />

                <div className="service-section__media">
                    <div className="service-note">
                        <Icon
                            className="service-note__icon"
                            type="info-circle"
                        />

                        <p className="service-note__text">
                            Если в СТС тягача или прицепа указано,
                            что VIN-номер отсутствует, установите
                            соответствующий флажок. После этого загрузите
                            остальные фотографии из обязательного списка.
                        </p>
                    </div>
                </div>
            </InstructionStep>

            <InstructionStep
                number="3"
                title="Отправьте фотографии"
            >
                <div className="instruction-copy">
                    <p>
                        Убедитесь, что все необходимые фотографии выбраны
                        и готовы к отправке.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/vehicle-inspection/03-required-photos.png"
                    alt="Кнопка отправки фотографий транспортного средства"
                    items={submitPhotoItems}
                />

                <div className="service-section__media">
                    <div className="service-note">
                        <Icon
                            className="service-note__icon"
                            type="info-circle"
                        />

                        <p className="service-note__text">
                            После передачи информации в 1С логист сможет
                            поставить транспортное средство на погрузку
                            или отправить его в рейс, а оператор —
                            распечатать документы по рейсу.
                        </p>
                    </div>
                </div>
            </InstructionStep>

            <section className="service-section">
                <h2 className="service-section__title">
                    Важные условия
                </h2>

                <p className="service-section__description">
                    Распечатывать развозники разрешено.
                </p>

                <p className="service-section__description">
                    По всем вопросам можно обращаться в группу
                    «Проверка ТС, водителя, прицепа через сайт».
                </p>

                <div className="service-highlight">
                    <span className="service-highlight__icon">
                        <Icon type="warning"/>
                    </span>

                    <div>
                        <strong className="service-highlight__title">
                            Нечитаемый или отсутствующий VIN
                        </strong>

                        <p className="service-highlight__text">
                            Если VIN-номер невозможно прочитать или подтвердить,
                            заведующий складом должен уведомить регионального
                            директора и логиста по корпоративной электронной
                            почте. Региональный директор в течение 10 минут
                            принимает решение об отказе в погрузке либо
                            о запросе гарантийного письма от перевозчика.
                            Если запрошено гарантийное письмо, склад прикрепляет
                            его вместо фотографии VIN-номера.
                        </p>
                    </div>
                </div>
            </section>
        </InstructionLayout>
    );
}